import { UrlTokenParser } from './url-token-parser';
import { AppUrls } from '@sxm-core/utility-code/typescript/browser-app-configs-types';

export function tokenReplaceAppUrls(appUrls: AppUrls) {
    const urlTokenParser = new UrlTokenParser();
    appUrls.careUSBaseUrl = urlTokenParser.replaceToken(
        appUrls.careUSBaseUrl,
        'us',
    );
    appUrls.careCanadaBaseUrl = urlTokenParser.replaceToken(
        appUrls.careCanadaBaseUrl,
        'ca',
    );
    appUrls.accountCenterUSBaseUrl = urlTokenParser.replaceToken(
        appUrls.accountCenterUSBaseUrl,
        'us',
    );
    appUrls.accountCenterCanadaBaseUrl = urlTokenParser.replaceToken(
        appUrls.accountCenterCanadaBaseUrl,
        'ca',
    );
    appUrls.onboardingClaimTrialUSBaseUrl = urlTokenParser.replaceToken(
        appUrls.onboardingClaimTrialUSBaseUrl,
        'us',
    );
    appUrls.onboardingClaimTrialCanadaBaseUrl = urlTokenParser.replaceToken(
        appUrls.onboardingClaimTrialCanadaBaseUrl,
        'ca',
    );
    appUrls.onboardingDeviceLinkingUSBaseUrl = urlTokenParser.replaceToken(
        appUrls.onboardingDeviceLinkingUSBaseUrl,
        'us',
    );
    appUrls.onboardingDeviceLinkingCanadaBaseUrl = urlTokenParser.replaceToken(
        appUrls.onboardingDeviceLinkingCanadaBaseUrl,
        'ca',
    );
    appUrls.acquisitionsSelfPayUSBaseUrl = urlTokenParser.replaceToken(
        appUrls.acquisitionsSelfPayUSBaseUrl,
        'us',
    );
    appUrls.acquisitionsSelfPayCanadaBaseUrl = urlTokenParser.replaceToken(
        appUrls.acquisitionsSelfPayCanadaBaseUrl,
        'ca',
    );
}
